import type { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import * as Sentry from '@sentry/angular';

export const sentryInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      // Skip expected auth errors — 401/403 are normal auth flows
      if (err.status === 401 || err.status === 403) {
        return throwError(() => err);
      }

      // Capture the error with Sentry
      // We only capture the status and statusText — no bodies, headers, or sensitive data
      const sentryEx = new Error(err.message);
      (sentryEx as unknown as { cause: unknown }).cause = err;
      Sentry.captureException(sentryEx, {
        contexts: {
          http: {
            status: err.status,
            statusText: err.statusText,
            url: req.url,
            method: req.method,
          },
        },
      });

      return throwError(() => err);
    }),
  );
};
